import React from "react";
import { Star } from "lucide-react";

export const StarRating = ({ value = 0, size = 16, onChange, testid }) => {
  const stars = [1, 2, 3, 4, 5];
  return (
    <div className="flex items-center gap-0.5" data-testid={testid}>
      {stars.map((s) => (
        <button
          key={s}
          type="button"
          disabled={!onChange}
          onClick={() => onChange && onChange(s)}
          className={onChange ? "cursor-pointer" : "cursor-default"}
          data-testid={onChange ? `star-${s}` : undefined}
          aria-label={`${s} star`}
        >
          <Star
            style={{ width: size, height: size }}
            className={s <= Math.round(value) ? "fill-gold text-gold" : "text-white/25"}
            strokeWidth={1.5}
          />
        </button>
      ))}
    </div>
  );
};

export default StarRating;
